import { biayaWorkshopList, biayaWorkshopDetail, queryBiayaWorkshopList, search, pagination } from "./state";

const mutations = {
    setBiayaWorkshopList: (state, res) => {
        if (state.biayaWorkshopList.data !== undefined) {
            state.biayaWorkshopList.data.main_data = [...state.biayaWorkshopList.data.main_data, ...res.data.main_data];
        } else {
            state.biayaWorkshopList = res;
        }
    },
    setBiayaWorkshopDetail: (state, res) => {
        state.biayaWorkshopDetail = res.data;
    },
    resetBiayaWorkshop: (state) => {
        state.biayaWorkshopList = biayaWorkshopList();
    },
    resetBiayaWorkshopDetail: (state) => {
        state.biayaWorkshopDetail = biayaWorkshopDetail();
    },

    // query
    setQueryBiayaWorkshopList: (state, query) => {
        state.queryBiayaWorkshopList = query;
    },
    resetQueryBiayaWorkshopList: (state) => {
        state.queryBiayaWorkshopList = queryBiayaWorkshopList();
    },

    // search
    setSearch: (state, search) => {
        state.search.key = search;
    },
    resetSearch: (state) => {
        state.search = search();
    },
    setIsSearch: (state, bool) => {
        state.isSearch = bool;
    },

    // filter
    setNextPagination: (state, payload) => {
        state.pagination.length = payload.data.main_data.length;
        state.pagination.pageNumber++;
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
    },
    resetPagination: (state, e) => {
        state.pagination = pagination();
    },

    setScrollPosition: (state, positionY) => {
        state.scrollPosition = positionY - 100;
    },
};

export default mutations;
